// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"bebd1e88","307":"34e7d245","686":"d229b3e8","739":"d8ce20b1","962":"d8ce20b1"}[chunkId] + ".chunk.css";
};